import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

const TooltipComponent = ({ children, name, className, preferredPosition = "bottom" }) => {
  const wrapperRef = useRef(null);
  const tooltipRef = useRef(null);
  const [coords, setCoords] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!visible || !name) return;

    const wrapper = wrapperRef.current;
    const tooltip = tooltipRef.current;
    if (!wrapper || !tooltip) return;

    const wrapperRect = wrapper.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();
    const viewport = {
      width: window.innerWidth,
      height: window.innerHeight,
    };

    const placements = ["bottom", "top", "right", "left"];
    let finalPlacement = preferredPosition;

    const fits = {
      bottom: wrapperRect.bottom + tooltipRect.height < viewport.height,
      top: wrapperRect.top - tooltipRect.height > 0,
      right: wrapperRect.right + tooltipRect.width < viewport.width,
      left: wrapperRect.left - tooltipRect.width > 0,
    };

    for (let pos of placements) {
      if (fits[pos]) {
        finalPlacement = pos;
        break;
      }
    }
    const space = 8;
    const base = {
      left: wrapperRect.left + window.scrollX,
      top: wrapperRect.top + window.scrollY,
    };

    let calculatedCoords = {};

    switch (finalPlacement) {
      case "bottom":
        calculatedCoords = {
          top: base.top + wrapperRect.height + space,
          left: base.left + wrapperRect.width / 2 - tooltipRect.width / 2,
        };
        break;
      case "top":
        calculatedCoords = {
          top: base.top - tooltipRect.height - space,
          left: base.left + wrapperRect.width / 2 - tooltipRect.width / 2,
        };
        break;
      case "right":
        calculatedCoords = {
          top: base.top + wrapperRect.height / 2 - tooltipRect.height / 2,
          left: base.left + wrapperRect.width + space,
        };
        break;
      case "left":
        calculatedCoords = {
          top: base.top + wrapperRect.height / 2 - tooltipRect.height / 2,
          left: base.left - tooltipRect.width - space,
        };
        break;
      default:
        break;
    }

    setCoords(calculatedCoords);
  }, [visible, name]);

  return (
    <>
      <div
        ref={wrapperRef}
        className={`${className || "tooltip-wrapper"} relative`}
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
      >
        {children}
      </div>

      {visible &&
        name &&
        createPortal(
          <div
            ref={tooltipRef}
            className={`fixed z-[1000] border border-white ${
              name?.length > 35 ? "tooltip-text-max" : "tooltip-text"
            }`}
            style={{
              top: coords?.top || 0,
              left: coords?.left || 0,
              visibility: coords ? "visible" : "hidden",
              opacity: coords ? 1 : 0,
              transition: "opacity 0.2s ease-in-out",
            }}
          >
            {name}
          </div>,
          document.body
        )}
    </>
  );
};

export default TooltipComponent;

